module.exports = __webpack_public_path__ + "img/sdg_es_(11).659c0a7e.png";